import React from 'react';
import './header.css'
import pic9 from '../../assets/pic9.png'
import Circlenav from '../common/circlenav-header';
import { supabase } from '../../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
const Headerr = () => {


 const [headericon, setheadericon]= useState([]);
      useEffect(() => {
      const getheadericon = async()=>{
          const res = await supabase.from('icons_navigation_mobile').select('*').order('id', { ascending: true });;;
    
      setheadericon(res.data);
      }
      getheadericon();
      }, []);

    const navigate = useNavigate();

    return ( 
        
            <header className='header-container'>
                <nav className='nav-header-container'>
                    <img src={pic9} alt='logo'  onClick={() => navigate('/home')} ></img>

                    <nav className='circles-nav-container'>
                        <Circlenav icon={headericon?.[0]?.img} alt={headericon?.[0]?.alt}
                         onClick={() => navigate(headericon?.[0]?.url)} />
                        <Circlenav icon={headericon?.[1]?.img} alt={headericon?.[1]?.alt} 
                        onClick={() => navigate(headericon?.[1]?.url)} />
                    </nav>
                </nav>
            </header>
      
     );
}
 
export default Headerr;